module.exports = __webpack_public_path__ + "img/icon-google.ebea0fcd.png";